import { ConservatoryPageModel } from 'models/ConservatoryPageModel';
import stepper from './Stepper/reducer';
import make from './Make/reducer';
import season from './Season/reducer';
import size from './Size/reducer';
import design from './Design/reducer';
import addons from './Addons/reducer';
import { combineReducers, ReducerOptionalMapObject } from 'store/createReducer';
import initialPageState from 'components/Pagelayout/initialPageState';

export default combineReducers<ConservatoryPageModel, ReducerOptionalMapObject>({
  ...initialPageState,
  stepper,
  make,
  season,
  size,
  design,
  addons
});
